import useGetPrerequisites from './useGetPrerequisites';
import useGetBooking from './useGetBooking';
import useGetStartTime from './useGetStartTime';
import useGetPaid from './useGetPaid';
import useGetBookingStationTime from './useGetBookingStationTime';
import useGetExperience from './useGetExperience';
import useGetStation from './useGetStation';
import useGetTier from './useGetTier';
import useGetPromos from './useGetPromos';

export default function useBookingGetters (locationId, bookingId) {
  const {
    location,
    bookings,
    currentTime,
  } = useGetPrerequisites(locationId);

  const {
    bookingStationTimesChanges,
    bookingStationTimesInStore,
    bookingStationTimes,
  } = useGetBookingStationTime(bookingId);
  const {
    defaultBooking,
    bookingChanges,
    bookingInStore,
    booking,
  } = useGetBooking(locationId, bookingId, bookingStationTimes);

  const { startTime } = useGetStartTime(booking, currentTime);
  const { paid } = useGetPaid(booking);
  const { experiences } = useGetExperience(locationId);
  const { stations, getExperienceStations } = useGetStation(locationId);
  const { getExperienceTiers } = useGetTier(experiences);
  const { getExperienceCoupons, getExperienceDiscounts } = useGetPromos(experiences);

  return {
    location,
    bookings,
    currentTime,
    defaultBooking,
    bookingChanges,
    bookingInStore,
    booking,
    startTime,
    paid,
    bookingStationTimesChanges,
    bookingStationTimesInStore,
    bookingStationTimes,
    experiences,
    stations,
    getExperienceStations,
    getExperienceTiers,
    getExperienceCoupons,
    getExperienceDiscounts,
  };
};
